import { createRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import App from "./App.tsx";
import "./index.css";
import { ThemeProvider } from "@/hooks/use-theme";
import { initSentry } from "@/lib/sentry";
import { initVitalsReporter } from "@/lib/vitals-reporter";
import { enablePerformanceMonitoring } from "@/lib/performance-monitor";

// Initialize Sentry first
initSentry();

createRoot(document.getElementById("root")!).render(
  <HelmetProvider>
    <ThemeProvider defaultTheme="light" storageKey="hticu-theme">
      <App />
    </ThemeProvider>
  </HelmetProvider>
);

// Initialize monitoring after React mounts to avoid race conditions
requestAnimationFrame(() => {
  // Enable performance monitoring in development
  if (process.env.NODE_ENV === "development") {
    enablePerformanceMonitoring();
  }
  
  // Initialize Core Web Vitals monitoring
  initVitalsReporter();
});
